module.exports = __webpack_public_path__ + "img/c-msg.f992ff30.png";